module.exports = __webpack_public_path__ + "img/person-chatting-on-laptop.b83a00c.svg";